$(document).ready(function(){
      
    /* start Скрытие dropdown селекторов при открытии нового */  
      
      /* open selector 2 */
      
      $(document).ready(function(){
        $(".form1 div:nth-child(2) span").click(function(){
          if ($(this).children('.arrow-4').hasClass('open')) {
              if ($(".form1 div:nth-child(3) span .arrow-4").hasClass('open')) {
                  /*$(this).removeClass('open');
                  $(this).parent().parent().children('.image_picker_selector').slideToggle(200);*/
                  $(".form1 div:nth-child(3) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(3) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(4) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(4) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(4) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(5) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(5) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(5) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(6) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(6) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(6) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(7) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(7) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(7) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(8) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(8) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(8) ul").slideToggle(200);
              }
          }
        });
      });
      
      
      /* open selector 3 */
      
      $(document).ready(function(){
        $(".form1 div:nth-child(3) span").click(function(){
          if ($(this).children('.arrow-4').hasClass('open')) {
              if ($(".form1 div:nth-child(2) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(2) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(2) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(4) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(4) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(4) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(5) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(5) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(5) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(6) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(6) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(6) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(7) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(7) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(7) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(8) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(8) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(8) ul").slideToggle(200);
              }
          }
        });
      });
      
      /* open selector 4 */
      
      $(document).ready(function(){
        $(".form1 div:nth-child(4) span").click(function(){
          if ($(this).children('.arrow-4').hasClass('open')) {
              if ($(".form1 div:nth-child(2) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(2) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(2) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(3) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(3) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(3) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(5) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(5) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(5) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(6) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(6) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(6) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(7) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(7) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(7) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(8) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(8) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(8) ul").slideToggle(200);
              }
          }
        });
      });
      
      /* open selector 5 */
      
      $(document).ready(function(){
        $(".form1 div:nth-child(5) span").click(function(){
          if ($(this).children('.arrow-4').hasClass('open')) {
              if ($(".form1 div:nth-child(2) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(2) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(2) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(3) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(3) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(3) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(4) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(4) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(4) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(6) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(6) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(6) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(7) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(7) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(7) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(8) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(8) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(8) ul").slideToggle(200);
              }
          }
        });
      });
      
      /* open selector 6 */
      
      $(document).ready(function(){
        $(".form1 div:nth-child(6) span").click(function(){
          if ($(this).children('.arrow-4').hasClass('open')) {
              if ($(".form1 div:nth-child(2) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(2) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(2) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(3) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(3) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(3) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(4) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(4) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(4) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(5) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(5) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(5) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(7) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(7) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(7) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(8) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(8) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(8) ul").slideToggle(200);
              }
          }
        });
      });
      
      /* open selector 7 */
      
      $(document).ready(function(){
        $(".form1 div:nth-child(7) span").click(function(){
          if ($(this).children('.arrow-4').hasClass('open')) {
              if ($(".form1 div:nth-child(2) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(2) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(2) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(3) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(3) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(3) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(4) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(4) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(4) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(5) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(5) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(5) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(6) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(6) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(6) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(8) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(8) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(8) ul").slideToggle(200);
              }
          }
        });
      });
      
      /* open selector 8 */
      
      $(document).ready(function(){
        $(".form1 div:nth-child(8) span").click(function(){
          if ($(this).children('.arrow-4').hasClass('open')) {
              if ($(".form1 div:nth-child(2) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(2) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(2) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(3) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(3) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(3) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(4) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(4) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(4) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(5) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(5) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(5) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(6) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(6) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(6) ul").slideToggle(200);
              }
              if ($(".form1 div:nth-child(7) span .arrow-4").hasClass('open')) {
                  $(".form1 div:nth-child(7) span .arrow-4").removeClass('open');
                  $(".form1 div:nth-child(7) ul").slideToggle(200);
              }
          }
        });
      });
      
    /* end Скрытие dropdown селекторов при открытии нового */   
      
    /* start Скрытие dropdown селекторов form2 при открытии нового */  
      
      /* open selector 1 */  
      
      $(document).ready(function(){
        $(".form2 div:nth-child(1) span").click(function(){
          if ($(this).children('.arrow-4').hasClass('open')) {
              if ($(".form2 div:nth-child(2) span .arrow-4").hasClass('open')) {
                  $(".form2 div:nth-child(2) span .arrow-4").removeClass('open');
                  $(".form2 div:nth-child(2) ul").slideToggle(200);
              }
              if ($(".form2 div:nth-child(3) span .arrow-4").hasClass('open')) {
                  $(".form2 div:nth-child(3) span .arrow-4").removeClass('open');
                  $(".form2 div:nth-child(3) ul").slideToggle(200);
              }
              if ($(".form2 div:nth-child(4) span .arrow-4").hasClass('open')) {
                  $(".form2 div:nth-child(4) span .arrow-4").removeClass('open');
                  $(".form2 div:nth-child(4) ul").slideToggle(200);
              }
          }
        });
      });
      
      /* open selector 2 */  
      
      $(document).ready(function(){
        $(".form2 div:nth-child(2) span").click(function(){
          if ($(this).children('.arrow-4').hasClass('open')) {
              if ($(".form2 div:nth-child(1) span .arrow-4").hasClass('open')) {
                  $(".form2 div:nth-child(1) span .arrow-4").removeClass('open');
                  $(".form2 div:nth-child(1) ul").slideToggle(200);
              }
              if ($(".form2 div:nth-child(3) span .arrow-4").hasClass('open')) {
                  $(".form2 div:nth-child(3) span .arrow-4").removeClass('open');
                  $(".form2 div:nth-child(3) ul").slideToggle(200);
              }
              if ($(".form2 div:nth-child(4) span .arrow-4").hasClass('open')) {
                  $(".form2 div:nth-child(4) span .arrow-4").removeClass('open');
                  $(".form2 div:nth-child(4) ul").slideToggle(200);
              }
          }
        });
      });
      
      /* open selector 3 */  
      
      $(document).ready(function(){
        $(".form2 div:nth-child(3) span").click(function(){
          if ($(this).children('.arrow-4').hasClass('open')) {
              if ($(".form2 div:nth-child(1) span .arrow-4").hasClass('open')) {
                  $(".form2 div:nth-child(1) span .arrow-4").removeClass('open');
                  $(".form2 div:nth-child(1) ul").slideToggle(200);
              }
              if ($(".form2 div:nth-child(2) span .arrow-4").hasClass('open')) {
                  $(".form2 div:nth-child(2) span .arrow-4").removeClass('open');
                  $(".form2 div:nth-child(2) ul").slideToggle(200);
              }
              if ($(".form2 div:nth-child(4) span .arrow-4").hasClass('open')) {
                  $(".form2 div:nth-child(4) span .arrow-4").removeClass('open');
                  $(".form2 div:nth-child(4) ul").slideToggle(200);
              }
          }
        });
      });
      
      /* open selector 4 */  
      
      $(document).ready(function(){
        $(".form2 div:nth-child(4) span").click(function(){
          if ($(this).children('.arrow-4').hasClass('open')) {
              if ($(".form2 div:nth-child(1) span .arrow-4").hasClass('open')) {
                  $(".form2 div:nth-child(1) span .arrow-4").removeClass('open');
                  $(".form2 div:nth-child(1) ul").slideToggle(200);
              }
              if ($(".form2 div:nth-child(2) span .arrow-4").hasClass('open')) {
                  $(".form2 div:nth-child(2) span .arrow-4").removeClass('open');
                  $(".form2 div:nth-child(2) ul").slideToggle(200);
              }
              if ($(".form2 div:nth-child(3) span .arrow-4").hasClass('open')) {
                  $(".form2 div:nth-child(3) span .arrow-4").removeClass('open');
                  $(".form2 div:nth-child(3) ul").slideToggle(200);
              }
          }
        });
      });
      
    /* end Скрытие dropdown селекторов form2 при открытии нового */ 
      
        $(document).ready(function () {
            $("[name=handle_mat]").on("change",function () {
            if ($("[value=22]").prop("selected")==true) {
            $("[value=51]").prop("disabled",true);
            } else $("[value=51]").prop("disabled",false); });
        });
    
        $(document).ready(function () {
            $("[name=tip_mat]").on("change",function () {
            if ($("[value=51]").prop("selected")==true) {
            $("[value=22]").prop("disabled",true);
            } else $("[value=22]").prop("disabled",false); });
        });
      
      
        $(document).ready(function () {
            $(".image_picker_selector").on("click",function () {
                if ($("#handle_mat option[value=22]").prop("selected")==true && $("#tip_mat option[value=52]").prop("selected")==true) {
                    $(".form1 div:nth-child(3) ul li:nth-child(1) div").css('background', '#08c');
                    $(".form1 div:nth-child(3) ul li:nth-child(1) div p").css('color', '#fff');
                    $(".form1 div:nth-child(3) ul li:nth-child(2) div").css({'background': '#fff', 'opacity': '0.3'});
                    $(".form1 div:nth-child(3) ul li:nth-child(2) div p").css('color', '#000'); 
                    $(".form1 div:nth-child(3) ul li:nth-child(2) div img").css('cursor', 'default'); 
                }   });
        });
        
        $(document).ready(function () {
            $(".image_picker_selector").on("click",function () {
                if ($("#handle_mat option[value=21]").prop("selected")==true) {
                    $(".form1 div:nth-child(3) ul li:nth-child(1) div").css('background', '');
                    $(".form1 div:nth-child(3) ul li:nth-child(1) div p").css('color', '');
                    $(".form1 div:nth-child(3) ul li:nth-child(2) div").css({'background': '', 'opacity': ''});
                    $(".form1 div:nth-child(3) ul li:nth-child(2) div p").css('color', ''); 
                    $(".form1 div:nth-child(3) ul li:nth-child(2) div img").css('cursor', ''); 
                }   });
        });
        
        
        $(document).ready(function () {
            $(".image_picker_selector").on("click",function () {
                if ($("#tip_mat option[value=51]").prop("selected")==true && $("#handle_mat option[value=21]").prop("selected")==true) {
                    $(".form2 div:nth-child(2) ul li:nth-child(1) div").css('background', '#08c');
                    $(".form2 div:nth-child(2) ul li:nth-child(1) div p").css('color', '#fff');
                    $(".form2 div:nth-child(2) ul li:nth-child(2) div").css({'background': '#fff', 'opacity': '0.3'});
                    $(".form2 div:nth-child(2) ul li:nth-child(2) div p").css('color', '#000'); 
                    $(".form2 div:nth-child(2) ul li:nth-child(2) div img").css('cursor', 'default'); 
                }   });
        });  
        
        $(document).ready(function () {
            $(".image_picker_selector").on("click",function () {
                if ($("#tip_mat option[value=52]").prop("selected")==true) {
                    $(".form2 div:nth-child(2) ul li:nth-child(1) div").css('background', '');
                    $(".form2 div:nth-child(2) ul li:nth-child(1) div p").css('color', '');
                    $(".form2 div:nth-child(2) ul li:nth-child(2) div").css({'background': '', 'opacity': ''});
                    $(".form2 div:nth-child(2) ul li:nth-child(2) div p").css('color', ''); 
                    $(".form2 div:nth-child(2) ul li:nth-child(2) div img").css('cursor', '');
                }   });
        });  
    
    
    
        $(document).ready(function () {
            $(".image_picker_selector").on("click",function () {
                if ($(".form1 div:nth-child(3) ul li:nth-child(1) div").hasClass( "selected" )) {
                        $(".form1 div:nth-child(2) ul li:nth-child(1) .thumbnail .image_picker_image").attr( "src", "https://cdn.shopify.com/s/files/1/0523/1155/6263/files/tip_curved.jpg?v=1643811601" );
                        $(".form1 div:nth-child(2) ul li:nth-child(2) .thumbnail .image_picker_image").attr( "src", "https://cdn.shopify.com/s/files/1/0523/1155/6263/files/tip_straight.jpg?v=1643811600" );
                        $(".form1 div:nth-child(4) ul li:nth-child(1) .thumbnail .image_picker_image").attr( "src", "https://cdn.shopify.com/s/files/1/0523/1155/6263/files/tip_short.jpg?v=1643811601" );
                        $(".form1 div:nth-child(4) ul li:nth-child(2) .thumbnail .image_picker_image").attr( "src", "https://cdn.shopify.com/s/files/1/0523/1155/6263/files/tip_long.jpg?v=1643811601" );
                }
                else {
                        $(".form1 div:nth-child(2) ul li:nth-child(1) .thumbnail .image_picker_image").attr( "src", "https://cdn.shopify.com/s/files/1/0523/1155/6263/files/tip_curved_ti.jpg?v=1647504660" );
                        $(".form1 div:nth-child(2) ul li:nth-child(2) .thumbnail .image_picker_image").attr( "src", "https://cdn.shopify.com/s/files/1/0523/1155/6263/files/tip_straight_ti.jpg?v=1647504658" );
                        $(".form1 div:nth-child(4) ul li:nth-child(1) .thumbnail .image_picker_image").attr( "src", "https://cdn.shopify.com/s/files/1/0523/1155/6263/files/tip_short_ti.jpg?v=1647504658" );
                        $(".form1 div:nth-child(4) ul li:nth-child(2) .thumbnail .image_picker_image").attr( "src", "https://cdn.shopify.com/s/files/1/0523/1155/6263/files/tip_long_ti.jpg?v=1647504658" );
                }
            });    
        });
    
        $(document).ready(function () {
            $(".image_picker_selector").on("click",function () {
                if ($(".form2 div:nth-child(2) ul li:nth-child(1) div").hasClass( "selected" )) {
                        $(".form2 div:nth-child(1) ul li:nth-child(1) .thumbnail .image_picker_image").attr( "src", "https://cdn.shopify.com/s/files/1/0523/1155/6263/files/handle_flat_ti.jpg?v=1647504658" );
                        $(".form2 div:nth-child(1) ul li:nth-child(2) .thumbnail .image_picker_image").attr( "src", "https://cdn.shopify.com/s/files/1/0523/1155/6263/files/handle_round_ti.jpg?v=1647504658" );
                        $(".form2 div:nth-child(3) ul li:nth-child(1) .thumbnail .image_picker_image").attr( "src", "https://cdn.shopify.com/s/files/1/0523/1155/6263/files/handle_short_ti.jpg?v=1647504658" );
                        $(".form2 div:nth-child(3) ul li:nth-child(2) .thumbnail .image_picker_image").attr( "src", "https://cdn.shopify.com/s/files/1/0523/1155/6263/files/handle_medium_ti.jpg?v=1647504661" );
                        $(".form2 div:nth-child(3) ul li:nth-child(3) .thumbnail .image_picker_image").attr( "src", "https://cdn.shopify.com/s/files/1/0523/1155/6263/files/handle_long_ti.jpg?v=1647504658" );
                }
                else {
                        $(".form2 div:nth-child(1) ul li:nth-child(1) .thumbnail .image_picker_image").attr( "src", "https://cdn.shopify.com/s/files/1/0523/1155/6263/files/handle_flat.jpg?v=1643811600" );
                        $(".form2 div:nth-child(1) ul li:nth-child(2) .thumbnail .image_picker_image").attr( "src", "https://cdn.shopify.com/s/files/1/0523/1155/6263/files/handle_round.jpg?v=1643811600" );
                        $(".form2 div:nth-child(3) ul li:nth-child(1) .thumbnail .image_picker_image").attr( "src", "https://cdn.shopify.com/s/files/1/0523/1155/6263/files/handle_short.jpg?v=1643811601" );
                        $(".form2 div:nth-child(3) ul li:nth-child(2) .thumbnail .image_picker_image").attr( "src", "https://cdn.shopify.com/s/files/1/0523/1155/6263/files/handle_medium_39fd2ecc-5ae8-42a4-b2fe-e4fda2210ec8.jpg?v=1643811601" );
                        $(".form2 div:nth-child(3) ul li:nth-child(3) .thumbnail .image_picker_image").attr( "src", "https://cdn.shopify.com/s/files/1/0523/1155/6263/files/handle_long.jpg?v=1643811601" );
                }
            });    
        }); 
        
        let tip = document.querySelector(".tip");
        let hand = document.querySelector(".hand");
        //let handle = document.querySelector(".handle");
        let col = document.querySelector(".col");
        let btn = document.getElementById('btn');
        let btn2 = document.getElementById('btn2');
        let des = document.querySelector(".des");
        let ttl = document.querySelector(".ttl");
        let imgforc = document.getElementById('imgforc');
        let image__wrap1 = document.getElementById('image__wrap1');
        let image__wrap2 = document.getElementById('image__wrap2');
        let image__wrap_img1 = document.getElementById('image__wrap-img1');
        let image__wrap_img2 = document.getElementById('image__wrap-img2');
        let pick = document.querySelectorAll(".image_picker_image");
        let quan = 1;
        const client = ShopifyBuy.buildClient({
            domain: 'rumex-int.myshopify.com',
            storefrontAccessToken: 'de3eaa1410c236706a5463eed4e51172'
        });
        
            let x = '';
    
            let select1 = document.getElementById("tip_id");
            let selectedOption1 = select1.options[select1.selectedIndex];
            x = selectedOption1.value;
    
    
            let select2 = document.getElementById("handle_mat");
            let selectedOption2 = select2.options[select2.selectedIndex];
            x = x + selectedOption2.value;
    
            let select3 = document.getElementById("handle_type");
            let selectedOption3 = select3.options[select3.selectedIndex];
            x = x + selectedOption3.value;
    
            let select4 = document.getElementById("tip_type");
            let selectedOption4 = select4.options[select4.selectedIndex];
            x = x + selectedOption4.value;
    
            let select5 = document.getElementById("tip_mat");
            let selectedOption5 = select5.options[select5.selectedIndex];
            x = x + selectedOption5.value;
      
            let select6 = document.getElementById("tip_lever");
            let selectedOption6 = select6.options[select6.selectedIndex];
            x = x + selectedOption6.value;
      
            let select7 = document.getElementById("handle_len");
            let selectedOption7 = select7.options[select7.selectedIndex];
            x = x + selectedOption7.value;
    
            let sku = '';
            let id = '';
            let handle = '';
    
            switch (x) {
                case '11213141516172':
                    sku = '4-0395T';
                    id = '7459760308436';
                    handle = '4-0395t-capsulorhexis-forceps-with-scale-cross-action';
                    break;
                case '11213141526172':
                    sku = '4-0395';
                    id = '7459760406740';
                    handle = '4-0395-cross_action_capsulorrhexis_forceps_with_scale';
                    break;
                case '11213142516172':
                    sku = '4-0396/MFT';
                    id = '7598566834388';
                    handle = '4-0396_mft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142526172':
                    sku = '4-0396';
                    id = '7459760210132';
                    handle = '4-0396-capsulorhexis-forceps-with-scale-cross-action';
                    break;
                case '11213241516172':
                    sku = '4-0395/MRT';
                    id = '7598569455828';
                    handle = '4-0395_mrt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241526172':
                    sku = '4-0394';
                    id = '7459760472276';
                    handle = '4-0394-capsulorhexis-forceps-with-scale-cross-action';
                    break;
                case '11213242516172':
                    sku = '4-0396/MRT';
                    id = '7598566605012';
                    handle = '4-0396_mrt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242526172':
                    sku = '4-0396/MR';
                    id = '7598566768852';
                    handle = '4-0396_mr_capsulorhexis_forceps_with_scale';
                    break;
                case '11223141526172':
                    sku = '4-0395S';
                    id = '7459760373972';
                    handle = '4-0395s_capsulorhexis_forceps_with_scale';
                    break;
                case '11223142526172':
                    sku = '4-0396/MFS';
                    id = '7598566932692';
                    handle = '4-0396_mfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223241526172':
                    sku = '4-0395/MRS';
                    id = '7598569488596';
                    handle = '4-0395_mrs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223242526172':
                    sku = '4-0396/MRS';
                    id = '7598566703316';
                    handle = '4-0396_mrs_capsulorhexis_forceps_with_scale';
                    break;
                
                case '11213141516171':
                    sku = '4-0395/SFT';
                    id = '7598569193684';
                    handle = '4-0395_sft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213141526171':
                    sku = '4-0395/SF';
                    id = '7598569357524';
                    handle = '4-0395_sf_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142516171':
                    sku = '4-0396/SFT';
                    id = '7598566342868';
                    handle = '4-0396_sft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142526171':
                    sku = '4-0396/SF';
                    id = '7598566506708';
                    handle = '4-0396_sf_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241516171':
                    sku = '4-0395/SRT';
                    id = '7598568931540';
                    handle = '4-0395_srt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241526171':
                    sku = '4-0395/SR';
                    id = '7598569095380';
                    handle = '4-0395_sr_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242516171':
                    sku = '4-0396/SRT';
                    id = '7598566080724';
                    handle = '4-0396_srt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242526171':
                    sku = '4-0396/SR';
                    id = '7598566277332';
                    handle = '4-0396_sr_capsulorhexis_forceps_with_scale';
                    break;
                case '11223141526171':
                    sku = '4-0395/SFS';
                    id = '7598569291988';
                    handle = '4-0395_sfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223142526171':
                    sku = '4-0396/SFS';
                    id = '7598566441172';
                    handle = '4-0396_sfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223241526171':
                    sku = '4-0395/SRS';
                    id = '7598568997076';
                    handle = '4-0395_srs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223242526171':
                    sku = '4-0396/SRS';
                    id = '7598566211796';
                    handle = '4-0396_srs_capsulorhexis_forceps_with_scale';
                    break;
                
                case '11213141516173':
                    sku = '4-0395/LFT';
                    id = '7598569849044';
                    handle = '4-0395_lft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213141526173':
                    sku = '4-0395/LF';
                    id = '7598570143956';
                    handle = '4-0395_lf_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142516173':
                    sku = '4-0396/LFT';
                    id = '7598567194836';
                    handle = '4-0396_lft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142526173':
                    sku = '4-0396/LF';
                    id = '7598567358676';
                    handle = '4-0396_lf_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241516173':
                    sku = '4-0395/LRT';
                    id = '7598569586900';
                    handle = '4-0395_lrt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241526173':
                    sku = '4-0395/LR';
                    id = '7598569717972';
                    handle = '4-0395_lr_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242516173':
                    sku = '4-0396/LRT';
                    id = '7598566998228';
                    handle = '4-0396_lrt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242526173':
                    sku = '4-0396/LR';
                    id = '7598567129300';
                    handle = '4-0396_lr_capsulorhexis_forceps_with_scale';
                    break;
                case '11223141526173':
                    sku = '4-0395/LFS';
                    id = '7598569980116';
                    handle = '4-0395_lfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223142526173':
                    sku = '4-0396/LFS';
                    id = '7598567260372';
                    handle = '4-0396_lfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223241526173':
                    sku = '4-0395/LRS';
                    id = '7598569685204';
                    handle = '4-0395_lrs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223242526173':
                    sku = '4-0396/LRS';
                    id = '7598567063764';
                    handle = '4-0396_lrs_capsulorhexis_forceps_with_scale';
                    break;
                
                
                case '11213141516272':
                    sku = '4-03952/MFT';
                    id = '7598568046804';
                    handle = '4-03952_mft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213141526272':
                    sku = '4-03952/MF';
                    id = '7598568308948';
                    handle = '4-03952_mf_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142516272':
                    sku = '4-03962/MFT';
                    id = '7598565490900';
                    handle = '4-03962_mft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142526272':
                    sku = '4-03962/MF';
                    id = '7598565621972';
                    handle = '4-03962_mf_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241516272':
                    sku = '4-03952/MRT';
                    id = '7598567850196';
                    handle = '4-03952_mrt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241526272':
                    sku = '4-03952/MR';
                    id = '7598567981268';
                    handle = '4-03952_mr_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242516272':
                    sku = '4-03962/MRT';
                    id = '7598565261524';
                    handle = '4-03962_mrt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242526272':
                    sku = '4-03962/MR';
                    id = '7598565425364';
                    handle = '4-03962_mr_capsulorhexis_forceps_with_scale';
                    break;
                case '11223141526272':
                    sku = '4-03952/MFS';
                    id = '7598568210644';
                    handle = '4-03952_mfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223142526272':
                    sku = '4-03962/MFS';
                    id = '7598565556436';
                    handle = '4-03962_mfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223241526272':
                    sku = '4-03952/MRS';
                    id = '7598567948500';
                    handle = '4-03952_mrs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223242526272':
                    sku = '4-03962/MRS';
                    id = '7598565294292';
                    handle = '4-03962_mrs_capsulorhexis_forceps_with_scale';
                    break;
                
                case '11213141516271':
                    sku = '4-03952/SFT';
                    id = '7598567620820';
                    handle = '4-03952_sft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213141526271':
                    sku = '4-03952/SF';
                    id = '7598567784660';
                    handle = '4-03952_sf_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142516271':
                    sku = '4-03962/SFT';
                    id = '7598565032148';
                    handle = '4-03962_sft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142526271':
                    sku = '4-03962/SF';
                    id = '7598565163220';
                    handle = '4-03962_sf_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241516271':
                    sku = '4-03952/SRT';
                    id = '7598567391444';
                    handle = '4-03952_srt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241526271':
                    sku = '4-03952/SR';
                    id = '7598567522516';
                    handle = '4-03952_sr_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242516271':
                    sku = '4-03962/SRT';
                    id = '7598564770004';
                    handle = '4-03962_srt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242526271':
                    sku = '4-03962/SR';
                    id = '7598564933844';
                    handle = '4-03962_sr_capsulorhexis_forceps_with_scale';
                    break;
                case '11223141526271':
                    sku = '4-03952/SFS';
                    id = '7598567751892';
                    handle = '4-03952_sfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223142526271':
                    sku = '4-03962/SFS';
                    id = '7598565064916';
                    handle = '4-03962_sfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223241526271':
                    sku = '4-03952/SRS';
                    id = '7598567489748';
                    handle = '4-03952_srs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223242526271':
                    sku = '4-03962/SRS';
                    id = '7598564868308';
                    handle = '4-03962_srs_capsulorhexis_forceps_with_scale';
                    break;
                
                case '11213141516273':
                    sku = '4-03952/LFT';
                    id = '7598568702164';
                    handle = '4-03952_lft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213141526273':
                    sku = '4-03952/LF';
                    id = '7598568866004';
                    handle = '4-03952_lf_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142516273':
                    sku = '4-03962/LFT';
                    id = '7598565851348';
                    handle = '4-03962_lft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142526273':
                    sku = '4-03962/LF';
                    id = '7598565982420';
                    handle = '4-03962_lf_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241516273':
                    sku = '4-03952/LRT';
                    id = '7598568407252';
                    handle = '4-03952_lrt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241526273':
                    sku = '4-03952/LR';
                    id = '7598568669396';
                    handle = '4-03952_lr_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242516273':
                    sku = '4-03962/LRT';
                    id = '7598565654740';
                    handle = '4-03962_lrt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242526273':
                    sku = '4-03962/LR';
                    id = '7598565785812';
                    handle = '4-03962_lr_capsulorhexis_forceps_with_scale';
                    break;
                case '11223141526273':
                    sku = '4-03952/LFS';
                    id = '7598568800468';
                    handle = '4-03952_lfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223142526273':
                    sku = '4-03962/LFS';
                    id = '7598565916884';
                    handle = '4-03962_lfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223241526273':
                    sku = '4-03952/LRS';
                    id = '7598568505556';
                    handle = '4-03952_lrs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223242526273':
                    sku = '4-03962/LRS';
                    id = '7598565720276';
                    handle = '4-03962_lrs_capsulorhexis_forceps_with_scale';
                    break;
                
                
                case '12213141516172':
                    sku = '4-03951/MFT';
                    id = '6210827288743';
                    handle = '';
                    break;
                case '12213141526172':
                    sku = '4-03951/MF';
                    id = '6207933218983';
                    handle = '';
                    break;
                case '12213142516172':
                    sku = '4-03961/MFT';
                    id = '6210853240999';
                    handle = '';
                    break;
                case '12213142526172':
                    sku = '4-03961/MF';
                    id = '6210825322663';
                    handle = '';
                    break;
                case '12213241516172':
                    sku = '4-03951/MRT';
                    id = '6210858385575';
                    handle = '';
                    break;
                case '12213241526172':
                    sku = '4-03951/MR';
                    id = '6210857664679';
                    handle = '';
                    break;
                case '12213242516172':
                    sku = '4-03961/MRT';
                    id = '6210860712103';
                    handle = '';
                    break;
                case '12213242526172':
                    sku = '4-03961/MR';
                    id = '6210862153895';
                    handle = '';
                    break;
                case '12223141526172':
                    sku = '4-03951/MFS';
                    id = '6210871525543';
                    handle = '';
                    break;
                case '12223142526172':
                    sku = '4-03961/MFS';
                    id = '6210881519783';
                    handle = '';
                    break;
                case '12223241526172':
                    sku = '4-03951/MRS';
                    id = '6210875064487';
                    handle = '';
                    break;
                case '12223242526172':
                    sku = '4-03961/MRS';
                    id = '6210879324327';
                    handle = '';
                    break;
            }
    
            document.getElementById('sku').innerHTML = sku;
            document.getElementById('sku-mobile').innerHTML = sku;
            v = id;
            w = handle;
              
            /*let myInit = {
              headers: {
                'X-Shopify-Access-Token': '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'
              }
            }
            
            var data = null;
            fetch('https://rumex-com.myshopify.com/admin/api/2022-01/products/' + id + '.json', myInit)
            .then(response => response.json())
            .then(function(data) {
                document.getElementById('stock').innerHTML = data.product.variants[0].price.slice( 0, 3 );
                document.getElementById('stock-mobile').innerHTML = data.product.variants[0].price.slice( 0, 3 );
                des.innerHTML = data.product.body_html;
                document.getElementById('ttl').innerHTML = data.product.title.slice( 5 );
                document.getElementById('ttl-mobile').innerHTML = data.product.title.slice( 5 );
                imgforc.src = data.product.image.src;
            });  */

            client.product.fetchByHandle(handle).then((product) => {
                /*document.getElementById('stock').innerHTML = '$'+product.variants[0].price.slice( 0, 3 );
                document.getElementById('stock-mobile').innerHTML = '$'+product.variants[0].price.slice( 0, 3 );*/
                des.innerHTML = product.descriptionHtml;
                document.getElementById('ttl').innerHTML = product.title.slice( 5 );
                document.getElementById('ttl-mobile').innerHTML = product.title.slice( 5 );
                imgforc.src = product.images[0].src;
                /*if (product.variants[0].compareAtPrice > 0) {
                  document.getElementById('oldprice').innerHTML = '$'+product.variants[0].compareAtPrice.slice( 0, 3 );
                  document.getElementById('oldprice-mobile').innerHTML = '$'+product.variants[0].compareAtPrice.slice( 0, 3 );
                } else {
                  document.getElementById('oldprice').innerHTML = '';
                  document.getElementById('oldprice-mobile').innerHTML = '';
                }*/
            });
    
        $(".form1 div:nth-child(3) ul li:nth-child(2) div").on("click",function () {
            if ($("#handle_mat option[value=22]").prop("selected")==true) {
                $("#tip_mat").val(52);
                $(".form1 div:nth-child(3) ul li:nth-child(1) div").addClass("selected"); 
                $(".form1 div:nth-child(3) ul li:nth-child(2) div").removeClass("selected");  
            }
        });
    
    
        $(".form2 div:nth-child(2) ul li:nth-child(2) div").on("click",function () {
            if ($("#tip_mat option[value=51]").prop("selected")==true) {
                $("#handle_mat").val(21);
                $(".form2 div:nth-child(2) ul li:nth-child(1) div").addClass("selected");
                $(".form2 div:nth-child(2) ul li:nth-child(2) div").removeClass("selected");  
            }
        });
        
        $('.image_picker_selector').click(function(){
          if (document.getElementById("handle_mat").options[document.getElementById("handle_mat").selectedIndex].value == '22' && document.getElementById("tip_mat").options[document.getElementById("tip_mat").selectedIndex].value == '51') {}
          else {
            let x = '';
    
            let select1 = document.getElementById("tip_id");
            let selectedOption1 = select1.options[select1.selectedIndex];
            x = selectedOption1.value;
    
    
            let select2 = document.getElementById("handle_mat");
            let selectedOption2 = select2.options[select2.selectedIndex];
            x = x + selectedOption2.value;
    
            let select3 = document.getElementById("handle_type");
            let selectedOption3 = select3.options[select3.selectedIndex];
            x = x + selectedOption3.value;
    
            let select4 = document.getElementById("tip_type");
            let selectedOption4 = select4.options[select4.selectedIndex];
            x = x + selectedOption4.value;
    
            let select5 = document.getElementById("tip_mat");
            let selectedOption5 = select5.options[select5.selectedIndex];
            x = x + selectedOption5.value;
          
            let select6 = document.getElementById("tip_lever");
            let selectedOption6 = select6.options[select6.selectedIndex];
            x = x + selectedOption6.value;
      
            let select7 = document.getElementById("handle_len");
            let selectedOption7 = select7.options[select7.selectedIndex];
            x = x + selectedOption7.value;
    
            let sku = '';
            let id = '';
            let handle = '';
    
            switch (x) {
                case '11213141516172':
                    sku = '4-0395T';
                    id = '7459760308436';
                    handle = '4-0395t-capsulorhexis-forceps-with-scale-cross-action';
                    break;
                case '11213141526172':
                    sku = '4-0395';
                    id = '7459760406740';
                    handle = '4-0395-cross_action_capsulorrhexis_forceps_with_scale';
                    break;
                case '11213142516172':
                    sku = '4-0396/MFT';
                    id = '7598566834388';
                    handle = '4-0396_mft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142526172':
                    sku = '4-0396';
                    id = '7459760210132';
                    handle = '4-0396-capsulorhexis-forceps-with-scale-cross-action';
                    break;
                case '11213241516172':
                    sku = '4-0395/MRT';
                    id = '7598569455828';
                    handle = '4-0395_mrt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241526172':
                    sku = '4-0394';
                    id = '7459760472276';
                    handle = '4-0394-capsulorhexis-forceps-with-scale-cross-action';
                    break;
                case '11213242516172':
                    sku = '4-0396/MRT';
                    id = '7598566605012';
                    handle = '4-0396_mrt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242526172':
                    sku = '4-0396/MR';
                    id = '7598566768852';
                    handle = '4-0396_mr_capsulorhexis_forceps_with_scale';
                    break;
                case '11223141526172':
                    sku = '4-0395S';
                    id = '7459760373972';
                    handle = '4-0395s_capsulorhexis_forceps_with_scale';
                    break;
                case '11223142526172':
                    sku = '4-0396/MFS';
                    id = '7598566932692';
                    handle = '4-0396_mfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223241526172':
                    sku = '4-0395/MRS';
                    id = '7598569488596';
                    handle = '4-0395_mrs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223242526172':
                    sku = '4-0396/MRS';
                    id = '7598566703316';
                    handle = '4-0396_mrs_capsulorhexis_forceps_with_scale';
                    break;
                
                case '11213141516171':
                    sku = '4-0395/SFT';
                    id = '7598569193684';
                    handle = '4-0395_sft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213141526171':
                    sku = '4-0395/SF';
                    id = '7598569357524';
                    handle = '4-0395_sf_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142516171':
                    sku = '4-0396/SFT';
                    id = '7598566342868';
                    handle = '4-0396_sft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142526171':
                    sku = '4-0396/SF';
                    id = '7598566506708';
                    handle = '4-0396_sf_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241516171':
                    sku = '4-0395/SRT';
                    id = '7598568931540';
                    handle = '4-0395_srt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241526171':
                    sku = '4-0395/SR';
                    id = '7598569095380';
                    handle = '4-0395_sr_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242516171':
                    sku = '4-0396/SRT';
                    id = '7598566080724';
                    handle = '4-0396_srt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242526171':
                    sku = '4-0396/SR';
                    id = '7598566277332';
                    handle = '4-0396_sr_capsulorhexis_forceps_with_scale';
                    break;
                case '11223141526171':
                    sku = '4-0395/SFS';
                    id = '7598569291988';
                    handle = '4-0395_sfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223142526171':
                    sku = '4-0396/SFS';
                    id = '7598566441172';
                    handle = '4-0396_sfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223241526171':
                    sku = '4-0395/SRS';
                    id = '7598568997076';
                    handle = '4-0395_srs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223242526171':
                    sku = '4-0396/SRS';
                    id = '7598566211796';
                    handle = '4-0396_srs_capsulorhexis_forceps_with_scale';
                    break;
                
                case '11213141516173':
                    sku = '4-0395/LFT';
                    id = '7598569849044';
                    handle = '4-0395_lft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213141526173':
                    sku = '4-0395/LF';
                    id = '7598570143956';
                    handle = '4-0395_lf_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142516173':
                    sku = '4-0396/LFT';
                    id = '7598567194836';
                    handle = '4-0396_lft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142526173':
                    sku = '4-0396/LF';
                    id = '7598567358676';
                    handle = '4-0396_lf_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241516173':
                    sku = '4-0395/LRT';
                    id = '7598569586900';
                    handle = '4-0395_lrt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241526173':
                    sku = '4-0395/LR';
                    id = '7598569717972';
                    handle = '4-0395_lr_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242516173':
                    sku = '4-0396/LRT';
                    id = '7598566998228';
                    handle = '4-0396_lrt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242526173':
                    sku = '4-0396/LR';
                    id = '7598567129300';
                    handle = '4-0396_lr_capsulorhexis_forceps_with_scale';
                    break;
                case '11223141526173':
                    sku = '4-0395/LFS';
                    id = '7598569980116';
                    handle = '4-0395_lfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223142526173':
                    sku = '4-0396/LFS';
                    id = '7598567260372';
                    handle = '4-0396_lfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223241526173':
                    sku = '4-0395/LRS';
                    id = '7598569685204';
                    handle = '4-0395_lrs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223242526173':
                    sku = '4-0396/LRS';
                    id = '7598567063764';
                    handle = '4-0396_lrs_capsulorhexis_forceps_with_scale';
                    break;
                
                
                case '11213141516272':
                    sku = '4-03952/MFT';
                    id = '7598568046804';
                    handle = '4-03952_mft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213141526272':
                    sku = '4-03952/MF';
                    id = '7598568308948';
                    handle = '4-03952_mf_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142516272':
                    sku = '4-03962/MFT';
                    id = '7598565490900';
                    handle = '4-03962_mft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142526272':
                    sku = '4-03962/MF';
                    id = '7598565621972';
                    handle = '4-03962_mf_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241516272':
                    sku = '4-03952/MRT';
                    id = '7598567850196';
                    handle = '4-03952_mrt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241526272':
                    sku = '4-03952/MR';
                    id = '7598567981268';
                    handle = '4-03952_mr_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242516272':
                    sku = '4-03962/MRT';
                    id = '7598565261524';
                    handle = '4-03962_mrt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242526272':
                    sku = '4-03962/MR';
                    id = '7598565425364';
                    handle = '4-03962_mr_capsulorhexis_forceps_with_scale';
                    break;
                case '11223141526272':
                    sku = '4-03952/MFS';
                    id = '7598568210644';
                    handle = '4-03952_mfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223142526272':
                    sku = '4-03962/MFS';
                    id = '7598565556436';
                    handle = '4-03962_mfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223241526272':
                    sku = '4-03952/MRS';
                    id = '7598567948500';
                    handle = '4-03952_mrs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223242526272':
                    sku = '4-03962/MRS';
                    id = '7598565294292';
                    handle = '4-03962_mrs_capsulorhexis_forceps_with_scale';
                    break;
                
                case '11213141516271':
                    sku = '4-03952/SFT';
                    id = '7598567620820';
                    handle = '4-03952_sft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213141526271':
                    sku = '4-03952/SF';
                    id = '7598567784660';
                    handle = '4-03952_sf_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142516271':
                    sku = '4-03962/SFT';
                    id = '7598565032148';
                    handle = '4-03962_sft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142526271':
                    sku = '4-03962/SF';
                    id = '7598565163220';
                    handle = '4-03962_sf_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241516271':
                    sku = '4-03952/SRT';
                    id = '7598567391444';
                    handle = '4-03952_srt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241526271':
                    sku = '4-03952/SR';
                    id = '7598567522516';
                    handle = '4-03952_sr_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242516271':
                    sku = '4-03962/SRT';
                    id = '7598564770004';
                    handle = '4-03962_srt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242526271':
                    sku = '4-03962/SR';
                    id = '7598564933844';
                    handle = '4-03962_sr_capsulorhexis_forceps_with_scale';
                    break;
                case '11223141526271':
                    sku = '4-03952/SFS';
                    id = '7598567751892';
                    handle = '4-03952_sfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223142526271':
                    sku = '4-03962/SFS';
                    id = '7598565064916';
                    handle = '4-03962_sfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223241526271':
                    sku = '4-03952/SRS';
                    id = '7598567489748';
                    handle = '4-03952_srs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223242526271':
                    sku = '4-03962/SRS';
                    id = '7598564868308';
                    handle = '4-03962_srs_capsulorhexis_forceps_with_scale';
                    break;
                
                case '11213141516273':
                    sku = '4-03952/LFT';
                    id = '7598568702164';
                    handle = '4-03952_lft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213141526273':
                    sku = '4-03952/LF';
                    id = '7598568866004';
                    handle = '4-03952_lf_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142516273':
                    sku = '4-03962/LFT';
                    id = '7598565851348';
                    handle = '4-03962_lft_capsulorhexis_forceps_with_scale';
                    break;
                case '11213142526273':
                    sku = '4-03962/LF';
                    id = '7598565982420';
                    handle = '4-03962_lf_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241516273':
                    sku = '4-03952/LRT';
                    id = '7598568407252';
                    handle = '4-03952_lrt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213241526273':
                    sku = '4-03952/LR';
                    id = '7598568669396';
                    handle = '4-03952_lr_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242516273':
                    sku = '4-03962/LRT';
                    id = '7598565654740';
                    handle = '4-03962_lrt_capsulorhexis_forceps_with_scale';
                    break;
                case '11213242526273':
                    sku = '4-03962/LR';
                    id = '7598565785812';
                    handle = '4-03962_lr_capsulorhexis_forceps_with_scale';
                    break;
                case '11223141526273':
                    sku = '4-03952/LFS';
                    id = '7598568800468';
                    handle = '4-03952_lfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223142526273':
                    sku = '4-03962/LFS';
                    id = '7598565916884';
                    handle = '4-03962_lfs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223241526273':
                    sku = '4-03952/LRS';
                    id = '7598568505556';
                    handle = '4-03952_lrs_capsulorhexis_forceps_with_scale';
                    break;
                case '11223242526273':
                    sku = '4-03962/LRS';
                    id = '7598565720276';
                    handle = '4-03962_lrs_capsulorhexis_forceps_with_scale';
                    break;
                
                
                case '12213141516172':
                    sku = '4-03951/MFT';
                    id = '6210827288743';
                    handle = '';
                    break;
                case '12213141526172':
                    sku = '4-03951/MF';
                    id = '6207933218983';
                    handle = '';
                    break;
                case '12213142516172':
                    sku = '4-03961/MFT';
                    id = '6210853240999';
                    handle = '';
                    break;
                case '12213142526172':
                    sku = '4-03961/MF';
                    id = '6210825322663';
                    handle = '';
                    break;
                case '12213241516172':
                    sku = '4-03951/MRT';
                    id = '6210858385575';
                    handle = '';
                    break;
                case '12213241526172':
                    sku = '4-03951/MR';
                    id = '6210857664679';
                    handle = '';
                    break;
                case '12213242516172':
                    sku = '4-03961/MRT';
                    id = '6210860712103';
                    handle = '';
                    break;
                case '12213242526172':
                    sku = '4-03961/MR';
                    id = '6210862153895';
                    handle = '';
                    break;
                case '12223141526172':
                    sku = '4-03951/MFS';
                    id = '6210871525543';
                    handle = '';
                    break;
                case '12223142526172':
                    sku = '4-03961/MFS';
                    id = '6210881519783';
                    handle = '';
                    break;
                case '12223241526172':
                    sku = '4-03951/MRS';
                    id = '6210875064487';
                    handle = '';
                    break;
                case '12223242526172':
                    sku = '4-03961/MRS';
                    id = '6210879324327';
                    handle = '';
                    break;
            }
    
            document.getElementById('sku').innerHTML = sku;
            document.getElementById('sku-mobile').innerHTML = sku;
            v = id;
            w = handle;
              
            /*let myInit = {
                headers: {
                    'X-Shopify-Access-Token': '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'
                }
            }
          
            var data = null;
            fetch('https://rumex-com.myshopify.com/admin/api/2022-01/products/' + id + '.json', myInit)
            .then(response => response.json())
            .then(function(data) {
                document.getElementById('stock').innerHTML = data.product.variants[0].price.slice( 0, 3 );
                document.getElementById('stock-mobile').innerHTML = data.product.variants[0].price.slice( 0, 3 );
                des.innerHTML = data.product.body_html;
                document.getElementById('ttl').innerHTML = data.product.title.slice( 5 );
                document.getElementById('ttl-mobile').innerHTML = data.product.title.slice( 5 );
                imgforc.src = data.product.image.src;
                quan = data.product.variants[0].inventory_quantity;
                if (quan > 0) {
                    $(".disclaimer").css( "display", "none" );
                    $("#btn").attr( "value", "Buy now" );
                    $("#btn-mobile").attr( "value", "Buy now" );
                    $("#btn2").css( "display", "none" );
                    $("#btn2-mobile").css( "display", "none" );
                }
                else {
                    $(".disclaimer").css( "display", "initial" );
                    $("#btn").attr( "value", "Make to order" );
                    $("#btn-mobile").attr( "value", "Make to order" );
                    $("#btn2").css( "display", "inline-block" );
                    $("#btn2-mobile").css( "display", "inline-block" );
                }
            });*/

            client.product.fetchByHandle(handle).then((product) => {
                /*document.getElementById('stock').innerHTML = '$'+product.variants[0].price.slice( 0, 3 );
                document.getElementById('stock-mobile').innerHTML = '$'+product.variants[0].price.slice( 0, 3 );*/
                des.innerHTML = product.descriptionHtml;
                document.getElementById('ttl').innerHTML = product.title.slice( 5 );
                document.getElementById('ttl-mobile').innerHTML = product.title.slice( 5 );
                imgforc.src = product.images[0].src;
                if (product.variants[0].sku == '4-0395' || product.variants[0].sku == '4-0395S' || product.variants[0].sku == '4-0395T' || product.variants[0].sku == '4-0394' || product.variants[0].sku == '4-0396') {
                    $(".disclaimer").css( "display", "none" );
                    /*$("#btn").attr( "value", "Buy now" );
                    $("#btn-mobile").attr( "value", "Buy now" );
                    $("#btn2").css( "display", "none" );
                    $("#btn2-mobile").css( "display", "none" );*/
                }
                else {
                    $(".disclaimer").css( "display", "initial" );
                    /*$("#btn").attr( "value", "Make to order" );
                    $("#btn-mobile").attr( "value", "Make to order" );
                    $("#btn2").css( "display", "inline-block" );
                    $("#btn2-mobile").css( "display", "inline-block" );*/
                }
                /*if (product.variants[0].compareAtPrice > 0) {
                  document.getElementById('oldprice').innerHTML = '$'+product.variants[0].compareAtPrice.slice( 0, 3 );
                  document.getElementById('oldprice-mobile').innerHTML = '$'+product.variants[0].compareAtPrice.slice( 0, 3 );
                } else {
                  document.getElementById('oldprice').innerHTML = '';
                  document.getElementById('oldprice-mobile').innerHTML = '';
                }*/
            });
      
          }   
        });
        
    
      
    
      
        /*$(btn).unbind("click").click(function() {
            client.product.fetchByHandle(w).then((product) => {
                location.href = '/cart/add?id=' + product.variants[0].id.substring(29) + '&quantity=1&utm_source=referral&utm_medium=constructor&utm_campaign=add_to_cart';
            });
        }); */ 
      
        /*$("#btn-mobile").unbind("click").click(function() {
            client.product.fetchByHandle(w).then((product) => {
                location.href = '/cart/add?id=' + product.variants[0].id.substring(29) + '&quantity=1&utm_source=referral&utm_medium=constructor&utm_campaign=add_to_cart';
            });      
        });*/
      
        $("#product-info").click(function() {
            window.open( '/products/' + w + '?utm_source=referral&utm_medium=constructor&utm_campaign=learn_more', "_blank");  
        });  
      
        $("#reset, #reset2").click(function() {
            location.href = "/pages/constructor?utm_source=referral&utm_medium=constructor&utm_campaign=default";
        });
      
        /*$(btn2).unbind("click").click(function() {
            window.open( "/collections/regular-cross-action-capsulorhexis-forceps?utm_source=referral&utm_medium=constructor&utm_campaign=go_to_regular_items", "_blank");
        });
      
        $("#btn2-mobile").unbind("click").click(function() {
            window.open( "/collections/regular-cross-action-capsulorhexis-forceps?utm_source=referral&utm_medium=constructor&utm_campaign=go_to_regular_items", "_blank");
        });*/
    
    });
    